import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import { statuses } from '../helper';

export const CampaignStatusRenderer = ({ value }) => {
  if (!value) return null;
  return (
    <Flex alignItems="center" height="100%" sx={{ gap: '8px', p: '8px' }}>
      <Flex
        alignItems="center"
        sx={{
          gap: '6px',
          borderRadius: '99px',
          display: 'flex',
          height: '17px',
          padding: '0 8px',
          justifyContent: 'center',
          alignItems: 'center',
          bg: statuses[value]?.bg,
          minHeight: '20px',
        }}
      >
        <Text
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontFamily: 'Silka',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '24px',
            color: statuses[value]?.color,
          }}
        >
          {statuses[value]?.label}
        </Text>
      </Flex>
    </Flex>
  );
};

CampaignStatusRenderer.propTypes = {
  value: PropTypes.string.isRequired,
};
